var NullValue = /* @__PURE__ */ ((NullValue2) => {
  NullValue2["NULL_VALUE"] = "NULL_VALUE";
  NullValue2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return NullValue2;
})(NullValue || {});
export {
  NullValue
};
//# sourceMappingURL=struct.enums.js.map
